<template>
  <transition name="component-fade" mode="out-in">
    <div v-show="listActive" class="list-container" @click="closeList"></div>
  </transition>
  <transition name="list-fade" mode="in-out">
    <div v-show="listActive" class="card bg-white shadow-sm pt-5 c-xf">
      <div
        class="d-flex justify-content-between align-items-center border-bottom pb-3"
        style="padding-right: 1.5rem"
      >
        <div>
          <h5 class="d-flex align-items-start flex-column m-0 p-6">
            {{ project.name }}
            <span class="text-muted mt-1 fw-bold fs-8">{{
              translate("project_detail_checklist_list_title")
            }}</span>
          </h5>
        </div>
        <div
          class="btn btn-icon btn-sm btn-active-light-primary ms-2 text-dark"
          @click="closeList"
          aria-label="Close"
        >
          <i class="bi bi-x-lg"></i>
        </div>
      </div>

      <div
        class="d-flex align-items-center justify-content-between pt-4 pe-4 pb-4 border-bottom position-relative"
        style="padding-left: 2.4rem !important; background: #fbfbfb"
      >
        <div class="form-check form-check-custom form-check-solid">
          <input
            ref="checkBox"
            class="form-check-input"
            type="checkbox"
            v-model="checkAllItem"
            @change="selectAll()"
          />
        </div>
        <div
          class="d-flex align-items-center justify-content-end position-relative"
        >
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <i class="bi bi-search fs-3 text-gray-600"></i>
            </span>
            <input
              type="text"
              class="form-control form-control-white ps-15 form-control-sm border"
              style="width: 250px"
              :placeholder="
                translate('project_detail_checklist_input_seacrh_placeholder')
              "
              v-model="filterObject.name"
              @keydown.enter="Search"
              @keyup.delete="inputNull"
            />
          </div>

          <button
            v-if="btnAddAll"
            type="button"
            class="btn btn-primary position-relative btn-sm ms-2"
            @click="addAllChecklist"
          >
            {{ translate("Add_All") }}
            <span
              class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
              >{{ totalRecordCount }}</span
            >
          </button>
          <button
            v-else-if="selectedItemValue > 0"
            type="button"
            class="btn btn-primary position-relative btn-sm ms-2"
            @click="addSelectChecklist"
          >
            {{ translate("Add") }}
            <span
              class="position-absolute top-0 start-100 translate-middle badge badge-circle badge-danger"
              >{{ selectedItemValue }}</span
            >
          </button>
        </div>
        <a
          v-show="!notData"
          class="text-muted mt-1 fs-8 position-absolute top-5"
          style="top: 71px; right: 15px"
          >{{ totalRecordCount }} {{ translate("Records_Found") }}</a
        >
      </div>

      <ul
        id="all-location"
        class="locations-list mt-2 pt-7 ps-3"
        @scroll="scrollPage($event)"
      >
        <div
          v-if="notData"
          class="d-flex justify-content-center align-items-center mt-10 mb-1 me-2 border rounded p-6 bg-light-info text-info"
        >
          {{ translate("No_Records") }}
        </div>
        <div
          v-for="(item, index) in checkLists"
          :key="index"
          class="d-flex align-items-center mb-1 me-2 border rounded"
        >
          <!--begin::Bullet-->
          <span class="bullet bullet-vertical h-40px bg-primary"></span>
          <!--end::Bullet-->

          <!--begin::Checkbox-->
          <div class="form-check form-check-custom form-check-solid mx-5">
            <input
              :disabled="checkAllItem === true && btnAddAll === true"
              class="form-check-input"
              type="checkbox"
              v-model="item.checked"
              :id="`checklist-${index}`"
            />
          </div>
          <!--end::Checkbox-->

          <!--begin::Description-->
          <div class="flex-grow-1">
            <div class="d-flex flex-column position-relative w-100">
              <label
                class="form-check-label col-form-label fw-bold p-0"
                :for="`checklist-${index}`"
              >
                {{ item.name }}
              </label>
            </div>
          </div>
          <!--end::Description-->
          <div
            class="btn btn-icon btn-sm btn-active-light-primary me-2"
            @click="addChecklist(item.id)"
          >
            <i class="bi bi-plus-lg"></i>
          </div>
        </div>
        <div
          v-if="loading"
          class="d-flex justify-content-center align-items-center mb-1 me-2 pt-2"
        >
          <span
            class="spinner-border spinner-border-sm align-middle text-primary"
          ></span>
        </div>
      </ul>
    </div>
  </transition>
</template>

<script setup>
import { useStore } from "vuex";
import ProjectModule from "@/store/modules/Customer/ProjectModule";
import {
  reactive,
  ref,
  defineProps,
  defineEmits,
  computed,
  inject,
  watch,
} from "vue";

import { useI18n } from "vue-i18n";

// Multi Language
const { t, te } = useI18n();
const translate = (text) => {
  if (te(text)) {
    return t(text);
  } else {
    return text;
  }
};

const store = useStore();
const project = inject("project");
const projectId = inject("projectId");
const props = defineProps({ listActive: Boolean }, { project: Object });
const emit = defineEmits(["closeList"]);

watch(props, () => {
  if (props.listActive) {
    lastData = false;
    filterObject.page = 1;
    filterObject.pageSize = 20;
    getChecklist();
  }
});

const selectedItemValue = computed(
  () => checkLists.value.filter((item) => item.checked === true).length
);
const loading = ref(false);
const checkLists = ref([]);
const totalRecordCount = ref(0);
const btnAddAll = ref(false);
const checkAllItem = ref(false);
const checkBox = ref();
const notData = ref(false);
let lastData = false;

// Filter
const filterObject = reactive({
  page: 1,
  pageSize: 20,
  projectId: parseInt(projectId),
  name: null,
});
const Search = () => {
  checkLists.value = [];
  getChecklist();
};
const inputNull = () => {
  if (filterObject.name === "" || filterObject.name === null) {
    filterObject.name = null;
    getChecklist();
  }
};

// Filter End

const closeList = () => {
  checkAllItem.value = false;
  emit("closeList");
};

const selectAll = (e) => {
  if (checkAllItem.value && checkLists.value.length > 0) {
    checkLists.value.forEach((item) => (item.checked = true));
    if (filterObject.name !== null) {
      btnAddAll.value = false;
    } else {
      btnAddAll.value = true;
    }
  } else if (!checkAllItem.value && checkLists.value.length > 0) {
    checkLists.value.forEach((item) => (item.checked = false));
    btnAddAll.value = false;
  }
};

function getChecklist() {
  if (!lastData) {
    loading.value = true;
    notData.value = false;
    ProjectModule.actions
      .GET_PROJECT_NOT_CHECKLIST(null, filterObject)
      .then((response) => {
        if (response.Success && response.Data.ListItems.length > 0) {
          totalRecordCount.value = response.Data.TotalItemsCount;
          response.Data.ListItems.forEach((element) => {
            if (!checkLists.value.some((item) => item.id === element.Id)) {
              var checlistItem = new Object();
              checlistItem.name = element.Name;
              checlistItem.checked = checkAllItem.value === true ? true : false;
              checlistItem.id = element.Id;
              checkLists.value.push(checlistItem);
            }
          });
        } else {
          lastData = true;
          if (checkLists.value.length === 0) notData.value = true;
        }
      })
      .finally(() => {
        loading.value = false;
      });
  }
}

function scrollPage(e) {
  let value = e.target.offsetHeight + Math.ceil(e.target.scrollTop);
  if (value >= e.target.scrollHeight) {
    filterObject.page = filterObject.page + 1;
    getChecklist(filterObject);
  }
}

const payload = reactive({
  projectId: parseInt(projectId),
  checklistIds: [],
  addAll: false,
});

function addAllChecklist() {
  payload.addAll = true;
  store
    .dispatch("ProjectModule/PROJECT_ADD_CHECKLIST", payload)
    .then((response) => {
      if (response) {
        checkLists.value = [];
        payload.addAll = false;
        getChecklist(filterObject);
        checkBox.value.checked = false;
        btnAddAll.value = false;
      }
    });
}
function addSelectChecklist() {
  checkLists.value
    .filter((item) => item.checked === true)
    .forEach((i) => payload.checklistIds.push(i.id));
  store
    .dispatch("ProjectModule/PROJECT_ADD_CHECKLIST", payload)
    .then((response) => {
      if (response) {
        checkLists.value = checkLists.value.filter((i) => i.checked === false);
        filterObject.pageSize = 25 + payload.checklistIds.length;
        filterObject.name = null;
        checkAllItem.value = false;
        getChecklist(filterObject);
        payload.checklistIds = [];
      }
    });
}
function addChecklist(Id) {
  payload.checklistIds = [];
  payload.checklistIds.push(Id);
  store
    .dispatch("ProjectModule/PROJECT_ADD_CHECKLIST", payload)
    .then((response) => {
      if (response) {
        checkLists.value = checkLists.value.filter((i) => i.checked === false);
        lastData = false;
        checkLists.value.splice(
          checkLists.value.findIndex((x) => x.id === Id),
          1
        );
        filterObject.pageSize = 21;
        getChecklist(filterObject);
        payload.checklistIds = [];
      }
    });
}

getChecklist(filterObject);
</script>

<style scoped>
.list-fade-enter-active,
.list-fade-leave-active {
  transition: all 0.5s ease;
}
.list-fade-enter-from,
.list-fade-leave-to {
  transform: translateX(500px);
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.5s ease;
}

.component-fade-enter-from,
.component-fade-leave-to {
  opacity: 0;
}
.list-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.219);
  z-index: 1200;
  overflow-x: hidden;
  overflow-y: auto;
}
.c-xf {
  position: fixed;
  width: 500px;
  height: 100vh;
  top: 0px;
  right: 0;
  z-index: 1201;
  border-radius: 5px 0 0 5px;
  overflow-x: hidden;
  overflow-y: auto;
}
@media only screen and (max-width: 600px) {
  .c-xf {
    width: 100%;
    border-radius: 0;
  }
}
.checklist-list {
  padding: 0%;
  background: white;
  width: 100%;
  max-height: 100vh;
  overflow: scroll;
  overflow-x: hidden;
}
</style>
